import type { QueryFunctionContext, UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import type { IScoringConfigDto } from "app/pages/sales-intelligence/sub-modules/signals/types";
import type { ScoringConfigType } from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";

import { leadScoringAgentQueryKeys } from "../key-factory/factory";

type UseLeadScoringConfigQueryOptions = {
    enabled?: boolean;
};

const useLeadScoringConfigQuery = (
    configType: ScoringConfigType,
    options: UseLeadScoringConfigQueryOptions = {},
): UseQueryResult<IScoringConfigDto> => {
    const { enabled = true } = options;

    return useQuery({
        queryKey: leadScoringAgentQueryKeys.config(configType),
        retry: 2,
        refetchOnMount: true,
        enabled,
        queryFn({ signal }: QueryFunctionContext): Promise<IScoringConfigDto> {
            return salesApiService.signals.fetchScoringConfig(configType, { cancellation: signal });
        },
    });
};

export default useLeadScoringConfigQuery;
